if (!customElements.get('media-gallery')) {
  customElements.define('media-gallery', class MediaGallery extends HTMLElement {
    constructor() {
      super();
      this.elements = {
        viewer: this.querySelector('[id^="GalleryViewer"]'),
        thumbnails: this.querySelector('[id^="GalleryThumbnails"]'),
        prevButton: this.querySelector('button[name="previous"]'),
        nextButton: this.querySelector('button[name="next"]'),
        activeMedia: this.querySelector('.is-active'),
        dots: this.querySelector('.media-gallery__dots'),
        slideList: this.querySelector('.media-gallery__list')
      }

      // Show Variant Image on page load if the URL has a variant query param
      const queryString = window.location.search;
      const urlParams = new URLSearchParams(queryString);

      if (!urlParams.has('variant')) {
        this.loadGallery();
      } else {
        const variantId = urlParams.get('variant');
        const productTemplateVariantSelects = document.getElementById(`MainProduct-${this.dataset.sectionId}`).querySelector('variant-selects');

        if (productTemplateVariantSelects) {
          //productTemplateVariantSelects.updateMasterIdWithVariantId(variantId);
        }

        setTimeout(() => {
          this.loadGallery();
        }, "1000");
      }

      if (this.elements.thumbnails) {
        this.elements.thumbnails.querySelectorAll('[data-target]').forEach((mediaToSwitch) => {
          mediaToSwitch.querySelector('button').addEventListener('click', this.setActiveMedia.bind(this, mediaToSwitch.dataset.target, false));
        });
      }

      if (this.elements.nextButton) {
        this.setArrowButtons(this.elements.activeMedia);

        this.elements.prevButton.addEventListener('click', this.onArrowButtonClick.bind(this));
        this.elements.nextButton.addEventListener('click', this.onArrowButtonClick.bind(this));
      }

      if (this.elements.dots) {
        this.elements.dots.querySelectorAll('[data-target]').forEach((dot) => {
          dot.addEventListener('click', this.onDotClick.bind(this));
        });
        this.observeSlideVisibility();
      }
    }

    loadGallery() {
      this.classList.add('is-loaded');
    }

    updateThumbnail(mediaId) {
      if (this.elements.thumbnails) {
        const activeThumbnail = this.elements.thumbnails.querySelector(`[data-target="${ this.dataset.galleryId}-${ mediaId }"]`);
        this.setActiveThumbnail(activeThumbnail);
      }
    }

    setActiveMedia(mediaId) {
      window.pauseAllMedia();
      this.preventPageShift();

      const activeMedia = this.querySelector(`[data-slide-media-id="${mediaId}"]`);

      this.elements.viewer.querySelectorAll('[data-slide-media-id]').forEach((element) => {
        const imageContainer = element.querySelector('.js-media-gallery-image-container');
        element.classList.remove('is-active');
        if (imageContainer) {
          imageContainer.classList.remove('loaded');
        }
      });

      const activeMediaImageContainer = activeMedia.querySelector('.js-media-gallery-image-container');
      activeMedia.classList.add('is-active');
      if (activeMediaImageContainer) {
        activeMediaImageContainer.classList.add('loaded');
      }

      this.preventStickyHeader();
      window.setTimeout(() => {
        if (this.elements.thumbnails) {
          activeMedia.parentElement.scrollTo({ left: activeMedia.offsetLeft });
        }

        if (this.elements.nextButton) {
          activeMedia.scrollIntoView({behavior: 'smooth', block: 'nearest', inline: 'nearest'});
        }
      });

      this.playActiveMedia(activeMedia);

      if (this.elements.thumbnails) {
        const activeThumbnail = this.elements.thumbnails.querySelector(`[data-target="${ mediaId }"]`);
        this.setActiveThumbnail(activeThumbnail);
      }

      this.setActiveDot(mediaId);
      this.setArrowButtons(activeMedia);

    }

    onDotClick(event) {
      event.preventDefault();
      const target = event.currentTarget.dataset.target;
      this.pendingDotTarget = target;
      clearTimeout(this.pendingDotTimer);
      this.pendingDotTimer = setTimeout(() => { this.pendingDotTarget = null; }, 1000);
      this.setActiveMedia(target);
    }

    setActiveDot(mediaId) {
      if (!this.elements.dots) return;
      this.elements.dots.querySelectorAll('[data-target]').forEach((dot) => {
        const isActive = dot.dataset.target === mediaId;
        dot.classList.toggle('is-active', isActive);
        if (isActive) {
          dot.setAttribute('aria-current', 'true');
        } else {
          dot.removeAttribute('aria-current');
        }
      });
    }

    observeSlideVisibility() {
      if (!this.elements.slideList || typeof IntersectionObserver === 'undefined') return;

      const observer = new IntersectionObserver((entries) => {
        let best = null;
        entries.forEach((entry) => {
          if (entry.isIntersecting && (best === null || entry.intersectionRatio > best.intersectionRatio)) {
            best = entry;
          }
        });
        if (best && best.intersectionRatio >= 0.5) {
          const mediaId = best.target.dataset.slideMediaId;
          if (!mediaId) return;
          if (this.pendingDotTarget) {
            if (mediaId !== this.pendingDotTarget) return;
            this.pendingDotTarget = null;
            clearTimeout(this.pendingDotTimer);
          }
          this.setActiveDot(mediaId);
        }
      }, {
        root: this.elements.slideList,
        threshold: [0.5, 0.75, 1.0]
      });

      this.elements.slideList.querySelectorAll('[data-slide-media-id]').forEach((slide) => {
        observer.observe(slide);
      });
    }

    setArrowButtons(activeMedia) {
      if (!this.elements.prevButton) return;
      if (activeMedia.previousElementSibling == null) {
        this.elements.prevButton.setAttribute('disabled', true);
      } else {
        this.elements.prevButton.removeAttribute('disabled');
      }

      if (activeMedia.nextElementSibling == null) {
        this.elements.nextButton.setAttribute('disabled', true);
      } else {
        this.elements.nextButton.removeAttribute('disabled');
      }
    }

    setActiveThumbnail(thumbnail) {
      if (!this.elements.thumbnails || !thumbnail) return;
      const thumbnailButton = thumbnail.querySelector('button');

      this.elements.thumbnails.querySelectorAll('button').forEach((element) => {(
        element.removeAttribute('aria-current'));
        element.classList.remove('is-active');
      });

      thumbnailButton.setAttribute('aria-current', true);
      thumbnailButton.classList.add('is-active');
      if (this.elements.thumbnails.isSlideVisible(thumbnail, 10)) return;

      this.elements.thumbnails.slider.scrollTo({ left: thumbnail.offsetLeft });
    }

    onArrowButtonClick(event) {
      event.preventDefault();
      this.preventPageShift();
      const scrollDirection = event.currentTarget.name;
      const currentMedia = this.elements.viewer.querySelector('.is-active');
      const previousMedia = currentMedia.previousElementSibling;
      const nextMedia = currentMedia.nextElementSibling;

      if (scrollDirection === 'previous' && previousMedia !== null) {
        this.setActiveMedia(previousMedia.dataset.slideMediaId);
      } else if (scrollDirection === 'next' && nextMedia !== null) {
        this.setActiveMedia(nextMedia.dataset.slideMediaId);
      }
    }

    playActiveMedia(activeItem) {
      window.pauseAllMedia();
      const deferredMedia = activeItem.querySelector('.js-deferred-media-autoplay');
      if (deferredMedia) deferredMedia.loadContent(false);
    }

    preventStickyHeader() {
      this.stickyHeader = this.stickyHeader || document.querySelector('sticky-header');
      if (!this.stickyHeader) return;
      this.stickyHeader.dispatchEvent(new Event('preventHeaderReveal'));
    }

    preventPageShift() {
      // To get the scroll position of current webpage
      const TopScroll = window.scrollY || document.documentElement.scrollTop;
      const LeftScroll = window.scrollX || document.documentElement.scrollLeft;

      // if scroll happens, set it to the previous value
      window.onscroll = function() {
        window.scrollTo(LeftScroll, TopScroll)
      };

      // renable scroll after 0.5 second
      setTimeout(() => {
        window.onscroll = function() {};
      }, 500);
    }
  });
}
